module.exports = __webpack_public_path__ + "img/kafei.0a408212.png";